import {FC, memo } from 'react';

import PrioridadeSolicitacaoTD from 'view/component/PrioridadeSolicitacaoTD/PrioridadeSolicitacaoTD';
import { SolicitacaoResumida } from 'model/solicitacao/SolicitacaoResumida';
import { TempoAtras } from 'view/component/Tempo/TempoAtras';
import { Situacoes } from 'model/solicitacao/Situacao';
import { SituacaoTag } from 'view/component/Situacao/SituacaoTag';
import { SolicitacaoLink } from '../SolicitacaoLink/SolicitacaoLink';
import { ItemTabelaComponentProps } from 'view/component/Tabela/model/ItemTabelaComponentProps';
import { PrioridadeTag } from 'view/component/Prioridade/PrioridadeTag';
import { Prioridades } from 'model/solicitacao/PrioridadeSolicitacao';
import { AvatarPessoaPesquisavel } from 'view/component/AvatarPessoa/AvatarPessoaPesquisavel';


export const SolicitacaoItemLista: FC<ItemTabelaComponentProps<SolicitacaoResumida>> = memo(({item}) => {
  return (
    <tr id={"issue-"+ item.id}>
      <PrioridadeSolicitacaoTD prioridade={item.prioridade.id} />
      <td className="center"><SolicitacaoLink solicitacao={item.id} resumo={item} /></td>
      <td className="center"><SituacaoTag situacao={Situacoes.byId(item.situacao?.id)} /></td>
      <td className="center">{item.classificacao?.nome ?? 'A definir'}</td>
      <td className="center">{item.idSolicitante ? <AvatarPessoaPesquisavel idInstitucional={item.idSolicitante} /> : "A definir"}</td>
      <td>{item.titulo.substr(0, 40)}</td> 
      <td className="center"><PrioridadeTag prioridade={Prioridades.byId(item.prioridade.id)} /></td>
      <td className="center">{item.unidadeResponsavel?.sigla ?? "A definir"}</td>
      <td className="center">{item.responsavelTecnico ? <AvatarPessoaPesquisavel idInstitucional={item.responsavelTecnico.idInstitucional} /> : "A definir"}</td>
      <td className="center"><TempoAtras data={item.dataCriacao} /></td>
    </tr>
  )
})
